import React, { useEffect, useRef, useState } from "react";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import HoverChange from "components/Homepage/HoverChange";
import Footer from "components/Footers/Footer";

import bghome from "assets/img/bghome.jpg";
import IndexNavbar2 from "components/Navbars/IndexNavbar2";
import aboutuspage from "assets/img/aboutuspage.jpg";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
import abtbannerr from "assets/img/abtbanner.webp";
import aboutimg1 from "assets/img/aboutimg1.png";
import aboutimg2 from "assets/img/aboutimg2.png";
import aboutimg3 from "assets/img/aboutimg3.png";
import aboutimg4 from "assets/img/aboutimg4.png";
import aboutcount from "assets/img/about-count.jpg";

const Aboutus = () => {
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Counting numbers
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);
  const [count5, setCount5] = useState(0);
  const sectionRef = useRef(null);
  const startedRef = useRef(false);

  const animateCount = (target, setter, duration) => {
    let start = 0;
    const increment = target / (duration / 10);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      setter(Math.ceil(start));
    }, 10);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startedRef.current) {
          animateCount(215, setCount1, 2500, true);
          animateCount(123, setCount2, 2500, true);
          animateCount(3245, setCount3, 2500, true);
          animateCount(35, setCount4, 2500, true);
          animateCount(30, setCount5, 2500);
          startedRef.current = true;
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Scroll down animation
  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target); // Stop observing the section once it's animated
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  return (
    <section>
      <IndexNavbar2 />
      <section className="xl:pt-28 lg:pt-28 md:pt-17 pt-17"></section>
      <section
        ref={(el) => sections.current.push(el)}
        style={{
          position: "relative",
          backgroundImage: `url(${bghome})`,
          // backgroundAttachment: "fixed",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16 lg:p-16 md:p-12 p-12">
                <h1 className="banner-font text-white xl:pt-16 font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                  {t("aboutcontent1")}
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-18 lg:mb-4 banner-font xl:text-lg text-lg">
                  {t("aboutcontent2")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          backgroundColor: "#f5f5f5",
          backgroundSize: "cover",
        }}
        className="animate-on-scroll"
      >
        <div className="container mx-auto overflow-hidden px-4 xl:py-16 xl:px-12 lg:py-8 py-6">
          <p className="uppercase banner-font text-sm text-md font-semibold text-center">
            {t("aboutcontent3")}
          </p>
          <h1 className="uppercase font-semibold banner-font text-black xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">
            {" "}
            {t("aboutcontent4")}{" "}
            <span className="text-md">{t("aboutcontent5")}</span>
          </h1>
          <div className="grid md:grid-cols-2 grid-cols-1 xl:pt-8 pt-8 xl:px-16">
            <div className="z-2 xl:ml-4 slide-from-left">
              <div className="bg-dark border-l xl:p-12 md:p-8 p-6 rounded-xl">
                <div className="text-left">
                  <h1 className="xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-white banner-font">
                    {" "}
                    {t("aboutcontent6")}
                  </h1>
                  <p className="xl:text-para text-justify xl:pt-6 md:pt-4 pt-2 text-base text-white banner-font">
                    {" "}
                    {t("aboutcontent7")}
                  </p>
                </div>
              </div>
            </div>
            <div className="xl:-ml-32 lg:-ml-32 md:-ml-24 md:mt-20 mt-4 xl:mt-0 lg:mt-8 slide-from-right">
              <video
                className="bgggg xl:mt-6 rounded-xl"
                src="/aboutus.mp4"
                autoPlay
                loop
                muted
              ></video>
            </div>
          </div>
        </div>
      </section>

      <HoverChange />

      <div
        ref={(el) => el && sections.current.push(el)}
        className="animate-on-scroll"
        style={{
          backgroundColor: "rgb(0 149 207 / 7%)",
        }}
      >
        <div className="container mx-auto px-4 xl:px-24 lg:px-16 xl:pb-16 md:px-4 lg:py-12 py-6">
          <p className="uppercase banner-font text-sm text-md font-semibold text-center">
            {" "}
            {t("aboutcontent8")}
          </p>
          <h1 className="uppercase font-semibold banner-font text-black pt-1 xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">
            {t("aboutcontent9")}
            <span className="text-md">{t("aboutcontent10")} </span>
            {t("aboutcontent11")}
          </h1>
          <div className="grid xl:pt-8 pt-4 md:pt-8 md:grid-cols-4 md:gap-4 gap-2 grid-cols-2">
            <a href="">
              <div className="action center-items xl:p-4 p-2">
                <img
                  alt="Your browser doe not supoort this image"
                  src={aboutimg1}
                  className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate"
                />
                <p className="xl:pt-4 pt-3 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                  {t("aboutcontent12")}

                  <span className="text-redd">{t("aboutcontent13")} </span>
                </p>
                <p className="pt-1 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                  {" "}
                  {t("aboutcontent14")}
                </p>
              </div>
            </a>
            <a href="">
              <div className="action center-items xl:p-4 p-2">
                <img
                  alt="Your browser doe not supoort this image"
                  src={aboutimg2}
                  className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate"
                />
                <p className="xl:pt-4 pt-3 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                  {" "}
                  {t("aboutcontent15")}
                  <span className="text-redd"> {t("aboutcontent16")} </span>
                </p>
                <p className="pt-1 text-center xl:text-para text-base  text-gray leading-relaxed headlineheight banner-font">
                  {" "}
                  {t("aboutcontent17")}
                </p>
              </div>
            </a>
            <a href="" className="xl:pt-1">
              <div className="action center-items xl:p-4 p-2">
                <img
                  alt="Your browser doe not supoort this image"
                  src={aboutimg3}
                  className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate"
                />
                <p className="xl:pt-4 pt-3 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                  {" "}
                  {t("aboutcontent18")}
                  <span className="text-redd"> {t("aboutcontent19")}</span>
                </p>
                <p className="pt-1 text-center xl:text-para text-base  text-gray leading-relaxed headlineheight banner-font">
                  {" "}
                  {t("aboutcontent20")}
                </p>
              </div>
            </a>
            <a href="">
              <div className="action center-items xl:p-4 p-2">
                <img
                  alt="Your browser doe not supoort this image"
                  src={aboutimg4}
                  className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate"
                />
                <p className="xl:pt-4 pt-3 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                  {" "}
                  {t("aboutcontent21")}
                  <span className="text-redd"> {t("aboutcontent22")}</span>
                </p>
                <p className="pt-1 text-center xl:text-para  text-base text-gray leading-relaxed headlineheight banner-font">
                  {" "}
                  {t("aboutcontent23")}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          backgroundImage: `url(${aboutcount})`,
          width: "100%",
          backgroundSize: "cover",
        }}
        className="animate-on-scroll xl:h-400 lg:w-400 xl:block lg:block md:block sm:block block"
      >
        <div className="">
          <div className="container relative mx-auto overflow-hidden hometext xl:px-16 lg:px-20 md:px-12 xl:py-12 px-4">
            <div className="text-gray">
              <div
                ref={sectionRef}
                className="grid md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 grid-cols-1 md:pb-0 pb-12 xl:mt-24 lg:mt-16 md:mt-16 xl:px-12 mt-8 text-animate"
              >
                <div className="center-items">
                  <h1 className="font-bold xl:text-5xl md:text-4xl text-white text-4xl pb-2">
                    {count1}+<p></p>
                  </h1>
                  <div className="small-border"></div>
                  <p className="text-white xl:pt-2 pt-2 xl:w-9/12 md:w-9/12 w-9/12 xl:text-para md:text-sm banner-font font-medium">
                    {t("aboutcontent24")}
                  </p>
                </div>

                <div className="center-items ">
                  <h1 className="font-bold xl:text-5xl md:text-4xl text-white text-4xl xl:pt-0 md:pt-0 pt-4 pb-2">
                    {count2}+<p></p>
                  </h1>
                  <div className="small-border"></div>
                  <p className="text-white xl:pt-2 pt-2 xl:w-9/12 md:w-9/12 w-9/12 xl:text-para md:text-sm banner-font font-medium">
                    {t("aboutcontent25")}
                  </p>
                </div>

                <div className="center-items  ">
                  <h1 className="font-bold xl:text-5xl md:text-4xl text-white text-4xl xl:pt-0 md:pt-0 pt-4 pb-2">
                    {count3}+<p></p>
                  </h1>
                  <div className="small-border"></div>
                  <p className="text-white xl:pt-2 pt-2 xl:w-9/12 md:w-9/12 w-9/12 xl:text-para md:text-sm banner-font font-medium">
                    {t("aboutcontent26")}
                  </p>
                </div>

                <div className="center-items ">
                  <h1 className="font-bold xl:text-5xl md:text-4xl text-white text-4xl xl:pt-0 md:pt-0 pt-4 pb-2">
                    {count4}+<p></p>
                  </h1>
                  <div className="small-border"></div>
                  <p className="text-white xl:pt-2 pt-2 xl:w-9/12 md:w-9/12 w-9/12 xl:text-para md:text-sm banner-font font-medium">
                    {t("aboutcontent27")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterSmallNew />
    </section>
  );
};
export default Aboutus;
